import React, {Component} from 'react';
import SearchResultList from './SearchResultList'
import SearchConfigPanel from './SearchConfigPanel'
import './App.css';
import request from 'superagent'
import ReactPaginate from 'react-paginate';
import { Pagination, Container, Grid, Menu, Dropdown, Button } from 'semantic-ui-react';

// API エンドポイント
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT

class App extends Component {
    constructor(props) {
        super(props);
        this.clearData();
        // this.state = {data : [], kw: ""}
        // this.fetchData = this.fetchData.bind(this);

    }
    clearData() {
        this.state = {
            res: [],
            total_entries: 0,
            total_pages: 1,
            data: [],
            kw: '',
            category: '',
            publish_state: [],
            page: 1,
            activePage: 1,
            sort_method: 'date'
        };
    }
    render() {
        return (
            <div className="App">
                <div id='renderhere'>
                    <Grid container id="main">
                        <Grid.Row>
                            <Grid.Column computer={4} tablet={16}>
                                <h1>Video Library</h1>
                                <SearchConfigPanel
                                    fetchData={this.fetchData.bind(this)}
                                    handleSubmit={this.handleSubmit.bind(this)}
                                    updateState={this.updateState.bind(this)}
                                />
                            </Grid.Column>
                            <Grid.Column computer={12} tablet={16}>
                                <SearchResultList
                                    data={this.state.data}
                                />
                                {(() => {
                                    if (this.state.total_entries > 0) {
                                        return (
                                            <div>
                                            {/*<div id="App-paginate">*/}
                                                {/*<Container>*/}
                                                    <Pagination
                                                        totalPages={this.state.total_pages}
                                                        onPageChange={this.handlePageClick}
                                                        boundaryRange={3}
                                                        firstItem={false}
                                                        lastItem={false}
                                                    />

                                            {/*</Container>*/}
                                            </div>
                                        )
                                    }
                                })()}
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>

                </div>
            </div>
        );
    }

    fetchData(page = 1) {
        request
            .get(
                API_ENDPOINT + "?mode=search" + "&query=" +
                escape(
                    "per_page=40" +
                    "&page=" + page +
                    "&publish_state=" + this.state.publish_state +
                    "&kw=" + this.state.kw +
                    "&category=" + this.state.category
                    // "&category=講義ビデオ"
                )
            )
            .end((err, res) => {
                if (err) {
                    console.log('error')
                } else {
                    console.log("fetched: " + encodeURIComponent(this.state.kw));
                    this.setState({
                        res: res,
                        total_entries: res.body.message.total_entries,
                        total_pages: res.body.message.total_pages,
                        // data: res
                    });
                }
            });
        request
            .get(
                API_ENDPOINT + "?mode=stats" + "&query=" +
                escape(
                    "per_page=40" +
                    "&page=" + page +
                    "&publish_state=" + this.state.publish_state +
                    "&kw=" + this.state.kw +
                    "&category=" + this.state.category
                    // "&category=講義ビデオ"
                )
            )
            .end((err, res) => {
                if (err) {
                    console.log('error')
                } else {
                    console.log("fetched: " + encodeURIComponent(this.state.kw));
                    this.setState({
                        // res: res,
                        data: res.body.result
                        // data: res
                    });
                }
            })
    }

    handleSubmit(event) {
        this.fetchData();
        event.preventDefault();
    }

    handlePageClick = (e, {activePage}) => {
        // this.clearData();
        this.setState({activePage});
        this.fetchData(activePage);
    }

    updateState(state){
        this.setState(state, this.fetchData);
    }

}


export default App;



// WEBPACK FOOTER //
// ./src/component/App.js